var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 79,
    viewBox: "0 0 62 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4218 77H45.2649M30.8433 65.4628V45.2727M30.8433 45.2727L19.3061 33.7354M30.8433 45.2727L42.3806 33.7354M13.0688 53.565C9.63503 50.8951 6.85394 47.4786 4.93625 43.5745C3.01855 39.6704 2.01455 35.3811 2.00031 31.0314C1.9282 15.3841 14.511 2.36864 30.1583 2.0081C36.2142 1.86455 42.1615 3.63126 47.1568 7.05768C52.1521 10.4841 55.9419 15.3963 57.9886 21.0976C60.0353 26.7988 60.2351 32.9998 58.5596 38.821C56.8841 44.6422 53.4184 49.7881 48.6539 53.529C47.6014 54.3425 46.7489 55.3859 46.1615 56.5795C45.5741 57.773 45.2674 59.085 45.2649 60.4153V62.5785C45.2649 63.3434 44.961 64.0771 44.4201 64.618C43.8792 65.1589 43.1455 65.4628 42.3806 65.4628H19.3061C18.5412 65.4628 17.8075 65.1589 17.2666 64.618C16.7257 64.0771 16.4218 63.3434 16.4218 62.5785V60.4153C16.4128 59.095 16.1067 57.7937 15.5263 56.6079C14.9458 55.422 14.1059 54.3821 13.0688 53.565Z",
    stroke: "url(#paint0_linear_554_1439)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1439",
    x1: 30.8425,
    y1: 2,
    x2: 30.8425,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EAFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4063B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704BA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovationIcon);
export default __webpack_public_path__ + "static/media/innovation_icon.72e1169720b5391684ed5ce05281e3e4.svg";
export { ForwardRef as ReactComponent };